import { AdvancedSearchDropdownController } from './advanced-search-dropdown.controller'

function advancedSearchDropdown () {
  return {
    restrict: 'E',
    scope: {
      selectedTags: '=',
      search: '<',
      tagSearch: '=',
      isOpen: '=',
      onSubmit: '<',
      onAssetClick: '<'
    },
    templateUrl: '/core/directives/advanced-search-dropdown/advanced-search-dropdown.html?$$REVISION$$',
    controller: AdvancedSearchDropdownController
  }
}
export { advancedSearchDropdown }
